import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ELearningService} from '../service/e-learning.service';
import {ELearningReportModel} from '../models/e-learning-list-item.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {NavService} from '../../../services/nav.service';
import {AnalyticsService} from '../../../services/analytics.service';
import {environment} from '../../../../environments/environment';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-e-learning-report',
    templateUrl: './e-learning-report.component.html',
    styleUrls: ['./e-learning-report.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})
export class ELearningReportComponent implements OnInit {

    eDelegateId: number = null;

    pageData: ELearningReportModel = null;
    pageDataValid = false;
    pageDataPromise: Promise<ELearningReportModel> = null;

    pageDataRefreshRequired = false;
    isRunEnabled = false;
    isRise = false;
    isReAttemptEnabled = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private analytics: AnalyticsService,
        private eLearningService: ELearningService,
        private linkSystem: NavService,
        public userService: UserService
    ) {
        // this.isRise = true; //(environment.theme === 'veeam');
    }

    ngOnInit() {
        this.eDelegateId = Number(this.activatedRoute.snapshot.paramMap.get('eDelegateId'));
    }

    ionViewWillEnter() {
        if (this.pageData === null || !this.pageDataValid) {
            this.pageDataPromise = this.eLearningService.getMyElearningReport(this.eDelegateId, true);
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('E-learning Overview');

        if (this.pageData === null || !this.pageDataValid) {
            this.pageDataPromise.then(data => {
                this.pageData = data;
                this.setRunEnabled();
                this.setReAttemptEnabled();
                this.pageDataValid = true;
            });
        }
    }

    doRefresh(event) {
        this.pageData = null;
        this.pageDataValid = false;
        this.eLearningService.getMyElearningReport(this.eDelegateId, true).then(data => {
            this.pageData = data;
            this.setRunEnabled();
            this.setReAttemptEnabled();
            this.pageDataValid = true;
            this.pageDataRefreshRequired = false;
            if (event.type === "ionRefresh") {
                event.target.complete();
            }
        });
    }

    setRunEnabled() {
        this.isRunEnabled = (
            !this.isRise && this.pageData.run.enabled
            || this.isRise && this.pageData.run.enabled && this.pageData.result.status !== 'Completed'
        );

        if (this.pageData.result.status === 'Completed') {
            this.analytics.trackEvent('elearning_updated', {
                elearning_id: this.pageData.program.id.toString(),
                elearning_title: this.pageData.program.title,
            });
        }
    }

    setReAttemptEnabled() {
        this.isReAttemptEnabled = !!this.pageData.program.ereattempts;
    }

    openCourse() {
        if (this.isRunEnabled) {
            this.analytics.trackEvent('elearning_run', {
                elearning_id: this.pageData.program.id.toString(),
                elearning_title: this.pageData.program.title,
            });

            this.pageDataRefreshRequired = true;
            this.eLearningService.registerMyElearningRun(this.eDelegateId);
            this.linkSystem.toLink(this.pageData.run.url);
        }
    }
}
